import { Artist } from './types';

export const theSmokeData: Artist[] = [
  {
    id: "narue-mon",
    name: "Naruemon Yimchavee",
    nameThai: "นฤมล ยิ้มชาวี",
    background: {
      en: "Gluay - Naruemon Yimchavee was born in Bangkok. She graduated from the School of Fine and Applied Arts, majoring in Communication Design, Bangkok University in 2017.",
      th: "นฤมล ยิ้มชาวี เกิดที่กรุงเทพฯ จบการศึกษาจากคณะศิลปกรรมศาสตร์และประยุกต์ศิลป์ สาขาการออกแบบสื่อสาร มหาวิทยาลัยกรุงเทพ ในปี 2560"
    },
    concept: {
      title: "Concept: The Seed",
      description: "The concept reflects the struggles of living in a polluted environment, symbolized by a seed unable to grow into a beautiful tree under smoky, dusty air.",
      descriptionThai: "แนวคิด: เมล็ดพันธุ์ - ผู้คนไม่สามารถหยุดหายใจได้แม้ในฤดูฝุ่นควัน ดังนั้นเธอต้องการสื่อภาพของผู้คนที่รู้สึกอึดอัดและไม่มีทางเลือก"
    },
    artworks: [
      {
        id: "the-seed",
        title: "The Seed",
        titleThai: "",
        image: "/images/narue-mon-seed.jpg",
        medium: "Linocut print on corn husk paper",
        mediumThai: "การพิมพ์ลายเส้นบนกระดาษเปลือกข้าวโพด",
        size: "29.7 × 42 cm",
        price: "7,000 Baht",
        priceThai: "7,000 บาท"
      }
    ]
  },
  {
    id: "wannawit",
    name: "Wannawit Patteep",
    nameThai: "วรรณวิชญ์ ปัตตีพงศ์",
    background: {
      en: "Born on April 7, 1990, Wannawit Patteep is currently a lecturer in Painting at the Faculty of Fine Arts, Chiang Mai University.",
      th: "เกิดวันที่ 4 กรกฎาคม 2533 ปัจจุบันเป็นอาจารย์สอนวิชาจิตรกรรม คณะวิจิตรศิลป์ มหาวิทยาลัยเชียงใหม่"
    },
    concept: {
      title: "Concept",
      description: "The artwork addresses the causes of forest fires in Northern Thailand, specifically rice cultivation and animal husbandry.",
      descriptionThai: "แนวคิด: นำเสนอสาเหตุของไฟป่าในภาคเหนือ โดยเฉพาะจากการเพาะปลูกข้าวและการเลี้ยงสัตว์"
    },
    artworks: [
      {
        id: "corn-cultivation",
        title: "การปลูกข้าวโพดเลี้ยงสัตว์ - Corn Cultivation",
        titleThai: "",
        image: "/images/wannawit-corn.jpg",
        medium: "Acrylic and line drawing on canvas",
        mediumThai: "อะคริลิคและการวาดเส้นบนผ้าใบ",
        size: "60 × 80 cm",
        price: "15,000 Baht",
        priceThai: "15,000 บาท"
      },
      {
        id: "forest-fire",
        title: "ปัญหาไฟป่า - Forest Fire Problems",
        titleThai: "",
        image: "/images/wannawit-forest.jpg",
        medium: "Acrylic and line drawing on canvas",
        mediumThai: "อะคริลิคและการวาดเส้นบนผ้าใบ",
        size: "60 × 80 cm",
        price: "15,000 Baht",
        priceThai: "15,000 บาท"
      }
    ]
  },
  {
    id: "burich",
    name: "Burich Fahkoom",
    nameThai: "บุริช ฟ้าคุ้ม",
    background: {
      en: "Bhurch Fahkoom, nicknamed Poy, is 23 years old and lives in Phitsanulok Province. He graduated with a bachelor's degree from Naresuan College, Faculty of Architecture, Department of Visual Arts Design, specializing in painting.",
      th: "สวัสดี ผมชื่อบุริช ฟ้าคุ้ม ชื่อเล่นปอย อายุ 23 ปี อาศัยอยู่จังหวัดพิษณุโลก จบปริญญาตรีจากวิทยาลัยนเรศวร คณะสถาปัตยกรรมศาสตร์ ภาควิชาการออกแบบทัศนศิลป์ สาขาจิตรกรรม"
    },
    concept: {
      title: "Concept",
      description: "Under the theme \"smoke-fire,\" his work is inspired by the dust and smoke pollution around him. He identified rice stubble burning by some farmers as a key cause and aims to raise awareness about its environmental and health impacts through his art.",
      descriptionThai: "ความคิดสร้างสรรค์ของภาพวาดภายใต้หัวข้อ \"ควัน-ไฟ\" แรงบันดาลใจมาจากการเผชิญกับมลพิษฝุ่นและควันที่เกิดขึ้นรอบตัวเรา"
    },
    artworks: [
      {
        id: "heatwave-1",
        title: "Heatwave 1",
        titleThai: "",
        image: "/images/Heatwave_1.jpg",
        medium: "Acrylic on canvas",
        mediumThai: "อะคริลิคบนผ้าใบ",
        size: "80 × 60 cm",
        price: "35,000 Baht",
        priceThai: "35,000 บาท"
      },
      {
        id: "method-waves-2",
        title: "Method Waves 2",
        titleThai: "",
        image: "/images/Method_Waves_2.jpg",
        medium: "Acrylic on canvas",
        mediumThai: "อะคริลิคบนผ้าใบ",
        size: "117 × 80 cm",
        price: "40,000 Baht",
        priceThai: "40,000 บาท"
      },
      {
        id: "heatwave-2",
        title: "Heatwave 2",
        titleThai: "",
        image: "/images/Heatwave_2.jpg",
        medium: "Acrylic on canvas",
        mediumThai: "อะคริลิคบนผ้าใบ",
        size: "80 × 117 cm",
        price: "45,000 Baht",
        priceThai: "45,000 บาท"
      }
    ]
  },
  {
    id: "kreetapol",
    name: "Kreetapol Thongkhum",
    nameThai: "กฤษฎาพล ทองคำ",
    background: {
      en: "Kreetapol Thongkhum is an artist based in Chiang Mai, Thailand, specializing in sculptures made from clay, wood, cement, and steel.",
      th: "กฤษฎาพล ทองคำ เป็นศิลปินในเชียงใหม่ ประเทศไทย สร้างประติมากรรมจากวัสดุหลากหลาย เช่น ดินเหนียว ไม้ ซีเมนต์ และเหล็ก"
    },
    concept: {
      title: "Concept: My Home Town",
      titleThai: "บ้านเกิดของฉัน",
      description: "The work expresses deep emotions and memories tied to Chiang Mai, his beloved hometown. It tells the story of friends Joshua, Jasmine, and Mila (JJM), who built their lives there but were forced to leave due to environmental challenges.",
      descriptionThai: "แนวคิด: บ้านเกิดของฉัน - ข้อความเต็มไปด้วยอารมณ์ลึกซึ้งและความทรงจำอันล้ำค่า เชียงใหม่เป็นสถานที่ที่คุณรักทั้งในฐานะบ้านเกิดและเป็นที่ที่มีความทรงจำดีๆ"
    },
    artworks: [
      {
        id: "jjm-1",
        title: "What You've Lost JJM 1",
        titleThai: "",
        image: "/images/kreetapol-jjm1.jpg",
        medium: "Ceramic, mixed media",
        mediumThai: "เซรามิก, สื่อผสม",
        size: "100 × 100 × 60 cm",
        price: "60,000 Baht",
        priceThai: "60,000 บาท"
      },
      {
        id: "jjm-2",
        title: "What You've Lost JJM 2",
        titleThai: "",
        image: "/images/kreetapol-jjm2.jpg",
        medium: "Ceramic, mixed media",
        mediumThai: "เซรามิก, สื่อผสม",
        size: "100 × 100 × 60 cm",
        price: "60,000 Baht",
        priceThai: "60,000 บาท"
      },
      {
        id: "jjm-3",
        title: "What You've Lost JJM 3",
        titleThai: "",
        image: "/images/kreetapol-jjm3.jpg",
        medium: "Ceramic, mixed media",
        mediumThai: "เซรามิก, สื่อผสม",
        size: "60 × 60 × 60 cm",
        price: "20,000 Baht",
        priceThai: "20,000 บาท"
      }
    ]
  },
  {
    id: "maya",
    name: "Maya Yakobi",
    nameThai: "มายา ยาโกบี",
    background: {
      en: "Maya Yakobi graduated from art school in 2020 in Tel Aviv, Israel. She is an analog photographer and illustrator who uses expired film in her photography.",
      th: "จบจากโรงเรียนศิลปะในปี 2563 ที่เทลอาวีฟ อิสราเอล เป็นช่างภาพอนาล็อกและนักวาดภาพประกอบ ใช้ฟิล์มหมดอายุในการถ่ายภาพ"
    },
    concept: {
      title: "Concept",
      description: "Initially struck by Chiang Mai's vibrancy, she expected her photos to reflect its liveliness. However, the developed images revealed an apocalyptic, mysterious atmosphere, aligning with her reflections on the city's smoke-covered state.",
      descriptionThai: "ตอนแรกประทับใจกับความมีชีวิตชีวาของเชียงใหม่ คาดว่าภาพถ่ายจะสะท้อนความสดใส แต่เมื่อล้างฟิล์มกลับได้ภาพที่ดูเหมือนวันสิ้นโลกและลึกลับ"
    },
    artworks: [
      {
        id: "coordinates-1",
        title: "18.799505, 98.971553",
        titleThai: "",
        image: "/images/maya-coordinates1.jpg",
        medium: "Film Photograph",
        mediumThai: "ภาพถ่ายฟิล์ม",
        size: "40 × 40 cm",
        price: "5,000 Baht",
        priceThai: "5,000 บาท"
      },
      {
        id: "coordinates-2",
        title: "18.796586, 98.973117",
        titleThai: "",
        image: "/images/maya-coordinates2.jpg",
        medium: "Film Photograph",
        mediumThai: "ภาพถ่ายฟิล์ม",
        size: "40 × 40 cm",
        price: "5,000 Baht",
        priceThai: "5,000 บาท"
      },
      {
        id: "coordinates-3",
        title: "18.796759, 98.969843",
        titleThai: "",
        image: "/images/maya-coordinates3.jpg",
        medium: "Film Photograph",
        mediumThai: "ภาพถ่ายฟิล์ม",
        size: "40 × 40 cm",
        price: "5,000 Baht",
        priceThai: "5,000 บาท"
      }
    ]
  },
  {
    id: "suzanna",
    name: "Suzanna Siriboon (Boon)",
    nameThai: "ซูซานนา ศิริบุญ (บุญ)",
    background: {
      en: "Suzanna Siriboon, known as Boon, is a multidisciplinary designer with over eight years of experience in visual communications.",
      th: "ซูซานนา ศิริบุญ หรือที่รู้จักในชื่อ Boon เป็นนักออกแบบหลากสาขา มีประสบการณ์กว่า 8 ปีในด้านการสื่อสารด้วยภาพ"
    },
    concept: {
      title: "Concept: Hazy Days",
      titleThai: "วันหมอกควัน",
      description: "\"Hazy Days\" explores Northern Thailand's smoky season, blending beauty and danger. The red sun, veiled by haze, reflects the hazardous PM2.5 levels.",
      descriptionThai: "\"วันหมอกควัน\" เป็นการสำรวจภาพของฤดูฝุ่นควันในภาคเหนือของไทย ที่ความสวยงามและอันตรายผสมผสานกัน"
    },
    artworks: [
      {
        id: "hazy-days",
        title: "Hazy Days",
        titleThai: "“Hazy Days”",
        image: "/images/suzanna-hazy-days.jpg",
        medium: "Large Print in Frame",
        mediumThai: "พิมพ์ขนาดใหญ่ในกรอบ",
        size: "61 × 91 cm",
        price: "5,000 Baht (includes frame)",
        priceThai: "5,000 บาท รวมกรอบ"
      },
      {
        id: "smokey-sun",
        title: "“Smokey Sun”",
        titleThai: "",
        image: "/images/suzanna-smokey-sun.jpg",
        medium: "Oil Painting on Natural Italian Linen Canvas",
        mediumThai: "สีน้ำมันบนผ้าลินินอิตาลีธรรมชาติ",
        size: "100 × 120 cm",
        price: "30,000 Baht",
        priceThai: "30,000 บาท"
      },
      {
        id: "hazy-days-print",
        title: "“Hazy Days”",
        titleThai: "",
        image: "/images/suzanna-hazy-days-print.jpg",
        medium: "Print",
        mediumThai: "พิมพ์",
        size: "29.7 × 42 cm",
        price: "500 Baht",
        priceThai: "500 บาท"
      }
    ]
  }
]; 